module.exports = __webpack_public_path__ + "img/changes.1f87e7f3.png";